import { render, staticRenderFns } from "./commodity_detail.vue?vue&type=template&id=587ef11e&scoped=true"
import script from "./commodity_detail.vue?vue&type=script&lang=js"
export * from "./commodity_detail.vue?vue&type=script&lang=js"
import style0 from "./commodity_detail.vue?vue&type=style&index=0&id=587ef11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ef11e",
  null
  
)

export default component.exports